
export const GetBookings = async ( firebase, user ) => {
  let cartArr = []

  try {
    const operator = ( user.role === 'admin' ) ? "!=" : "=="
    const condition = ( user.role === 'admin' ) ? "" : user._id

    const data = await firebase
      .firestore()
      .collection( "bookings" )
      .where( "user", operator, condition )
      .get()

    data.forEach( async doc => {
      const bookingData = await doc.data()
      bookingData.id = doc.id
      cartArr.push( bookingData )
    } )

    return cartArr
  } catch ( error ) {
    console.log( 'get bookings', { error } )
  }
}

export default GetBookings